import { Paper } from '@mui/material';
import { memo, PropsWithChildren, ReactElement } from 'react';

interface DetailContainerLayoutProps extends PropsWithChildren {
  elevation?: number;
}

export const DetailContainerLayout = memo(function ({
  children,
  elevation = 0,
}: DetailContainerLayoutProps): ReactElement {
  return (
    <Paper
      elevation={elevation}
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '10px',
      }}
    >
      {children}
    </Paper>
  );
});
